export const PENSIONGOALS_RESET = 'PENSIONGOALS_RESET';
export const PENSIONGOALS_STATE_UPDATED = 'PENSIONGOALS_STATE_UPDATED';
export const PENSIONGOALS_SAVE_REQUEST = 'PENSIONGOALS_SAVE_REQUEST';
export const PENSIONGOALS_SAVE_SUCCESS = 'PENSIONGOALS_SAVE_SUCCESS';
export const PENSIONGOALS_SAVE_FAILED = 'PENSIONGOALS_SAVE_FAILED';


